import { cva } from 'class-variance-authority';
import styles from '../../presentation/styles.module.scss';

export const toastVariants = cva(styles.wrapper, {
  variants: {
    status: {
      success: styles.success,
      danger: styles.danger,
    },
  },
  defaultVariants: {
    status: 'success',
  },
});
